import {useQuery, gql} from "@apollo/client";
import ReactMarkdown from "react-markdown";


const TODOS = gql`
  query GetTodos {
    todos {
      id
      title
      body
      status
      start_date
      end_date
    }
  }
`

export default function ToDoList() {

  const {loading, error, data} = useQuery(TODOS);
  if (loading) 
    return <p> Loading to do list from database. </p>;

  if (error) {
    console.log(error);
    return <p>Error loading to do list.</p>;
  }

  const todos = [...data.todos].map((todo) => (
    <div key={todo.id}>
      <ToDo {...todo} />
    </div>
  ));

  return (
    <div className="todoList">
      To Do List:
      {todos}
    </div>
  );
}

const ToDo = (props) => {
  return (
    <article className="todoItem">
      <div className="todoTitle">{props.title}</div>
      <em className="todoDate">Start date: {new Date(props.start_date).toDateString()}<br/><br/></em>
      <ReactMarkdown>{props.body}</ReactMarkdown>
    </article>
    
  )
}
